module.exports = __webpack_public_path__ + "assets/img/img-about-01.f2abf4b8.jpg";